<app-header *ngIf="loginStatus"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="loginStatus"></app-footer>
<!-- <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner> -->